import { createSelector } from 'reselect';
import { sportExpeditionsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const sportExpeditionsYearsSelector = createSelector([sportExpeditionsSelector], (sportExpeditions) =>
  extractDatesFromNestedItems(
    [sportExpeditions.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
